import styles from './BottomNav.module.css';

const TABS = [
  { key: 'today',   label: 'Today',   icon: '✦' },
  { key: 'journal', label: 'Journal', icon: '📖' },
  { key: 'feed',    label: 'Feed',    icon: '🌐' },
  { key: 'friends', label: 'Settings', icon: '⚙️' },
];

export default function BottomNav({ activeTab, onTabChange, showTodayDot }) {
  return (
    <nav className={styles.nav}>
      {TABS.map(tab => (
        <button
          key={tab.key}
          className={`${styles.tab} ${activeTab === tab.key ? styles.active : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          <span className={styles.icon}>
            {tab.icon}
            {tab.key === 'today' && showTodayDot && (
              <span className={styles.dot} />
            )}
          </span>
          <span className={styles.label}>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
